import { render } from "./Signup.root.vue?vue&type=template&id=312b3a6c"
import script from "./Signup.root.vue?vue&type=script&lang=js"
export * from "./Signup.root.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__